export default "__VITE_ASSET__BQ32ax8M__"